    <div class="navegation-header" >
      <div class="navegation-header__icon" (click)="goback()">
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
      </div>
      <div class="navegation-header__tittle">
        <h3>{{title}}</h3>
      </div>
      <div class="cart-header__div-button" *ngIf="quantityCart > 0">
        <button (click)="actionClick()"><img src="assets/icons/lixeira-red.png" style="width: 15px;"/>Esvaziar</button>
      </div>
    </div>
